<template>
  <div>
    <b-card
      no-body
    >
      <div class="card-header">
        <b-card-title>Torneos</b-card-title>
      </div>

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- <b-button
              variant="primary"
              :to="{ name: 'tournaments-menu' }"
            >
              <span class="text-nowrap">Menú</span>
            </b-button> -->
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <b-button
                variant="primary"
                :to="{ name: 'tournaments-add'}"
              >
                <span class="text-nowrap">Nuevo torneo</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refTournamentListTable"
        :items="fetchTournaments"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
        responsive="sm"
        primary-key="id"
        empty-text="No se encontraron items"
        show-empty
        striped
      >
        <!-- Column: Status -->
        <template #cell(status)="data">
          {{ data.item.status ? 'SI' : 'NO' }}
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <div
              v-if="data.item.loading"
              class="text-center"
            >
              <b-spinner
                :id="`tournament-row-${data.item.id}-loading-icon`"
                small
              />
            </div>

            <div v-else>
              <feather-icon
                :id="`tournament-row-${data.item.id}-edit-icon`"
                icon="EditIcon"
                size="16"
                class="mx-1 cursor-pointer"
                @click="$router.push({ name: 'tournaments-edit', params: { id: data.item.id }})"
              />
              <b-tooltip
                title="Editar torneo"
                :target="`tournament-row-${data.item.id}-edit-icon`"
              />

              <div class="d-inline">
                <feather-icon
                  :id="`tournament-row-${data.item.id}-delete-icon`"
                  icon="TrashIcon"
                  size="16"
                  class="cursor-pointer"
                  @click="onDelete(data.item)"
                />
                <b-tooltip
                  title="Eliminar torneo"
                  :target="`tournament-row-${data.item.id}-delete-icon`"
                />
              </div>
            </div>
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalTournaments"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BCard,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BPagination,
  BTooltip,
  BSpinner,
} from 'bootstrap-vue'
// import { ref } from '@vue/composition-api'
import useTournaments from './useTournaments'

export default {
  components: {
    BCard,
    BTable,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BPagination,
    BTooltip,
    BSpinner,
  },
  setup() {
    const {
      fetchTournaments,
      tournamentDelete,
      tableColumns,
      perPage,
      currentPage,
      totalTournaments,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTournamentListTable,
      refetchData,
    } = useTournaments()

    // const isAddNewUserSidebarActive = ref(false)
    // const tournamentEditable = ref(null)

    // function onEdit(country) {
    //   tournamentEditable.value = { ...country }

    //   isAddNewUserSidebarActive.value = true
    // }

    async function onDelete(tournament) {
      try {
        const result = await this.$swal({
          title: '¿Estas seguro?',
          text: '¡No podrás revertir esta acción!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '¡Sí, bórralo!',
          cancelButtonText: 'Cancelar',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })

        if (result.value) {
          // eslint-disable-next-line no-param-reassign
          tournament.loading = true
          await tournamentDelete(tournament.id)
          // eslint-disable-next-line no-param-reassign
          tournament.loading = false
          refetchData()

          this.$swal({
            icon: 'success',
            title: '¡Borrado!',
            text: 'El item ha sido borrado',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      } catch (error) {
        console.log(error)
      }
    }

    return {
      // isAddNewUserSidebarActive,
      // tournamentEditable,
      refTournamentListTable,

      tableColumns,
      sortBy,
      isSortDirDesc,
      perPage,
      currentPage,
      totalTournaments,
      dataMeta,
      perPageOptions,
      searchQuery,
      fetchTournaments,
      refetchData,
      // onEdit,
      onDelete,
    }
  },
}
</script>
